import { Component, Input, OnInit } from "@angular/core";
import LocalizationConstants from "src/app/constants/localization-constants";
import { Department } from "src/app/models/Department";

import { Company } from "./../../models/Company";

@Component({
  selector: "department-select",
  templateUrl: "./department-select.component.html",
  styleUrls: ["./department-select.component.scss"],
  standalone: false,
})
export class DepartmentSelectComponent implements OnInit {
  @Input() company: Company;

  items: Department[] = [];

  localizationConstants = LocalizationConstants;

  constructor() {}

  ngOnInit() {
    this.items = [new Department(), ...this.company.departmentList];
  }

  selectAll() {
    this.company.departments = [...this.items];
  }

  unselectAll() {
    this.company.departments = [];
  }

  trackByFn(item: Department) {
    return item?.name;
  }
}
